const UI = (state, action) => {
  switch (action.type) {
    case 'NOTIFY_ON': {
      return {
        ...state,
        notify: {
          isOpen: true,
          type: action.payload.type,
          title: action.payload.title,
          message: action.payload.message,
          action: action.payload.action,
        },
      };
    }

    case 'NOTIFY_OFF': {
      return { ...state, notify: { isOpen: false } };
    }

    case 'LOADER_ON': {
      return { ...state, loading: true };
    }

    case 'LOADER_OFF': {
      return { ...state, loading: false };
    }

    default:
      throw new Error();
  }
};

export default UI;
